import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
// import Typography from '@material-ui/core/Typography';
import RadioButtonsGroup from '../../components/RadioButtonGroup/RadioButtonGroup';
import PricingCard from '../../components/PricingCard/PricingCard';
import { colors, fontFamily, fontSizes } from '../../styles/variables';
import { config as appConfig } from '../../../config';
// import transitions from '@material-ui/core/styles/transitions';
// import Typography from '@material-ui/core/Typography';

const featureItem1 = require('../../images/customer-service.svg');
const featureItem2 = require('../../images/paper.svg');
const featureItem3 = require('../../images/online-learning.svg');
const backgrounImage = require('../../images/pricingbackground.png');

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      paddingLeft: '4em',
      paddingRight: '4em',
      display: 'flex',
      justifyContent: 'center',
      '@media only screen and (max-width: 959px)': {
        paddingLeft: '4em',
        paddingRight: '7em',
      },
    },
    root2: {
      flexGrow: 1,
      paddingLeft: '9em',
      paddingRight: '0em',
      paddingBottom: '2em',
      paddingTop: '3em',
      display: 'flex',
      height: '100%',
      backgroundImage: `url(${backgrounImage})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      backgroundPosition: 'bottom',
      justifyContent: 'center',
      '@media only screen and (max-width: 959px)': {
        paddingLeft: '0em',
        backgroundImage: 'none',
        //paddingLeft:0,
        //paddingRight:0,
        // paddingLeft:10,
        // paddingRight:10,
        // maxWidth: "62%",
      },
    },
    root3: {
      flexGrow: 1,
      margin: 0,
      padding: 0,
      height: '100%',
      backgroundColor: colors.white
    },
    container: {
      margin: 0,
      marginTop: '-10rem',
      // padding:24,
      '@media only screen and (max-width: 959px)': {
        marginTop: 0,
        '&.MuiGrid-spacing-xs-8 > .MuiGrid-item': {
          padding: 10,
        }
      },
    },
    container2: {
      // margin:0,
      //marginRight:30,
      justifyContent: 'center',
      '&.MuiGrid-spacing-xs-10 > .MuiGrid-item': {
        padding: 80
      },
      '@media only screen and (max-width: 959px)': {
        marginRight: 0,
      },
    },
    featureWrapper: {
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'none',
      },
    },
    paper: {
      // height: 290,
      width: 279,
      borderRadius: 19,
      boxShadow: 'none',
      paddingBottom: 10,
      border: '1px solid transparent',
      transition: 'all 0.4s',
      '&.MuiGrid-spacing-xs-10 > .MuiGrid-item': {
        paddingBottom: 0,
      },
      '&:hover': {
        border: '1px solid #ea52619e',
      },
    },
    pricingCard: {
      // height: 360,
      width: 310,
      borderTopWidth: 20,
      borderTopColor: '#414141',
      borderTopStyle: 'solid',
      borderRadius: 19,
      boxShadow: '0px 0px 40px #0C207219',
      paddingBottom: 10,
    },
    control: {
      padding: theme.spacing(3),
    },
    featureItemImage: {
      width: 60,
      justifyContent: 'center',
      objectFit: 'contain'
    },
    featureItemImageDiv: {
      display: 'flex',
      paddingTop: 60,
      paddingBottom: 30,
      justifyContent: 'center',
      alignContent: 'center',

    },
    itemHeading: {
      fontFamily: fontFamily.poppins,
      fontSize: fontSizes.md.large,
      fontWeight: 'bolder',
      textAlign: 'center',
      color: 'black',
    },
    itemDescription: {
      fontFamily: fontFamily.poppins,
      fontSize: fontSizes.md.small,
      fontWeight: 'lighter',
      textAlign: 'center',
      color: colors.black,
      lineHeight: 2,
      paddingTop: 20,
      paddingLeft: 30,
      paddingRight: 30,
      overflow: 'hidden',
      height: 90
    },
    submitButton: {
      color: '#ffffff',
      background: 'linear-gradient(98deg, #414141 0%, #525252 100%)',
      borderRadius: 37,
      padding: '3% 10%',
      textTransform: 'uppercase',
      '&.MuiButton-contained': {
        outline: 'none'
      },
      '& .MuiTouchRipple-root span': {
        backgroundColor: 'transparent!important',
        color: '#ffffff',
        // opacity: 0.3,
      },
      '&.MuiButton-root.Mui-disabled':{
        color: '#b9b9b8',
      },
      '& .MuiButton-root.Mui-disabled': {
        color: '#ffffff5c',
      },
      '&:hover': {
        color: '#fff',
      },
    },
    submitButtonPink: {
      color: '#fff',
      background: 'linear-gradient(101deg, #DA4453 0%, #ED5565 100%) 0% 0%',
      borderRadius: 37,
      padding: '3% 10%',
      textTransform: 'uppercase',
      '&.MuiButton-root': {
        // padding:'6 56'
      },
      '&.MuiButton-contained': {
        outline: 'none'
      },
      '& .MuiTouchRipple-root span': {
        backgroundColor: 'transparent!important',
        color: '#fff',
        // opacity: 0.3,
      },
      '&:hover': {
        color: '#fff',
      },
    },
    pricingfeature: {
      fontSize: fontSizes.sm.regular,
      //  fontWeight:'bold',
      color: colors.black,
      textAlign: 'center',
      marginTop: '1em'
    },
    pricingfeature1: {
      height: '2.2em',
      textAlign: 'center',

    },
    pricingfeature2: {
      height: '2.2em',
      textAlign: 'center',

    },
    submitButtonDiv: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      alignContent: 'center',
      // padding:25,
      marginTop: '2em'
    },
    submitButtonDivPink: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      alignContent: 'center',
      marginTop: '2em'
      // padding:16
    },
    radioButtonGroup: {
      display: 'flex',
      justifyContent: 'center',
      textAlign: 'center',
      // marginTop:'2em',
    },
    priceMainDiv: {
      display: 'flex',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      paddingTop: '2em'
    },
  }),
);

export default function PricingPage() {
  const classes = useStyles();
  const signinURL = appConfig.screenappFrontendBaseUrl + '#/signin';
  return (
    <div className={classes.root3} >
      <Grid container className={classes.root}>
        <Grid item xs={12}>
          <Grid container justify="center" spacing={8} className={classes.container}>
            <Grid item spacing={2}>
              <a href="https://screenapp.io/blog/" target="new" className={classes.featureWrapper}>
                <Paper className={classes.paper}>
                  <div className={classes.featureItemImageDiv}>
                    <img src={featureItem2} alt="featuresimage" className={classes.featureItemImage} />
                  </div>
                  <div className={classes.itemHeading}>Documentation</div>
                  <div className={classes.itemDescription}>Read our 2 minutes quick start guide and be a pro!!!</div>
                </Paper>
              </a>
            </Grid>
            <Grid item spacing={2}>
              <a href="https://www.youtube.com/watch?v=BhwO40mzqG8" target="new" className={classes.featureWrapper}>
                <Paper className={classes.paper}>
                  <div className={classes.featureItemImageDiv}>
                    <img src={featureItem3} alt="featuresimage" className={classes.featureItemImage} />
                  </div>
                  <div className={classes.itemHeading}>Video Tutorial</div>
                  <div className={classes.itemDescription}>Bored to read, watch and learn</div>
                </Paper>
              </a>
            </Grid>
            <Grid item spacing={2}>
              <a href="#contact" className={classes.featureWrapper}>
                <Paper className={classes.paper}>
                  <div className={classes.featureItemImageDiv}>
                    <img src={featureItem1} alt="featuresimage" className={classes.featureItemImage} />
                  </div>
                  <div className={classes.itemHeading}>Online Support</div>
                  <div className={classes.itemDescription}>Send us any questions you have and we are here to guide you through the any issues</div>
                </Paper>
              </a>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container className={classes.root2} id="Pricing">
        <PricingCard
          heading1="BASIC"
          price1="$0"
          description="FOR INDIVIDUALS THAT NEED TO RECORD & SHARE QUICK VIDEOS."
        >
          <div className={classes.pricingfeature1}>
            {/* chdhjcdsc */}
          </div>
          <div className={classes.radioButtonGroup}>
            <RadioButtonsGroup
              lable1="Free Account"
              lable2="15 min recording"
              lable3="10 maximum recordings"
              lable5="10 local savings"
            />
          </div>
          <div className={classes.submitButtonDiv}>
            <Button href={signinURL} variant='contained' className={classes.submitButton}>GET STARTED</Button>
          </div>
        </PricingCard>
        <PricingCard
          heading2="STANDARD"
          price2="$1.99/mo"
          description="FOR BUSINESSES THAT NEED TO RECORD & SHARE QUICK VIDEOS."
        >
          <div className={classes.pricingfeature2}>

          </div>
          <div className={classes.radioButtonGroup}>
            <RadioButtonsGroup
              lable1="1 hour recording"
              lable2="Unlimited recordings"
              lable3="Unlimited local savings"
              lable5="Folders creations"
            />
          </div>
          <div className={classes.submitButtonDivPink}>
            <Button href={signinURL} variant="contained" className={classes.submitButtonPink}>GET STARTED</Button>
          </div>
        </PricingCard>
        <PricingCard
          heading1="PREMIUM"
          price1="$4.99/mo"
          description="FOR ENTERPRISES THAT NEED TO RECORD & SHARE QUICK VIDEOS."
        >
          <div className={classes.pricingfeature}>
            Everything in Standard plan , plus
              </div>

          <div className={classes.radioButtonGroup}>
            <RadioButtonsGroup
              lable1="2 hour recording"
              lable2="Cloud backup"
              lable3="Trim"
              lable5="Link creation and share"
            />
          </div>
          <div className={classes.submitButtonDiv}>
            <Button disabled  className={classes.submitButton}>Coming soon</Button>
          </div>
        </PricingCard>
      </Grid>
    </div>
  );
}
